import { GET_FOOTER_PORTAL } from '../../constants';
import { GET_CONTENT } from '@plone/volto/constants/ActionTypes';

const initialState = {
  error: null,
  items: {},
  loaded: false,
  loading: false,
};

export const getFooterPortalReducer = (
  state = initialState,
  action: { type?: string; result?: any; error?: any } = {},
) => {
  switch (action.type) {
    case `${GET_FOOTER_PORTAL}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };

    case `${GET_CONTENT}_SUCCESS`:
      // O '?. Operador' evita que o código quebre se o componente não vier na resposta
      if (action.result?.['@components']?.footerPortal?.items) {
        return {
          ...state,
          error: null,
          items: action.result['@components'].footerPortal.items,
          loaded: true,
          loading: false,
        };
      }
      return state;

    case `${GET_FOOTER_PORTAL}_SUCCESS`:
      return {
        ...state,
        error: null,
        items: action.result?.items || {},
        loaded: true,
        loading: false,
      };

    case `${GET_FOOTER_PORTAL}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };

    default:
      return state;
  }
};

export default getFooterPortalReducer;
